import React from 'react';
import '../styles/AdminLanding.css';

function AdminLanding({ onLogout = () => {} }) {
  const go = (path) => {
    window.location.href = path;
  };

  return (
    <div className="admin-landing">
      <div className="admin-landing-card">
        <h1>Admin</h1>
        <p><strong>Admin inloggad</strong></p>
        <p>Välj sida att redigera.</p>
        <div className="admin-landing-actions">
          <button onClick={() => go('/admin/home')}>Edit Home</button>
          <button onClick={() => go('/admin/aboutus')}>Edit About us</button>
          <button onClick={() => go('/admin/faq')}>Edit FAQ</button>
          <button onClick={onLogout}>Logga ut</button>
        </div>
      </div>
    </div>
  );
}

export default AdminLanding;
